import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

export class ModelAccountWalletTransaction extends BaseReactiveClass {
  static STATUS_PENDING = 'pending';
  static STATUS_PROCESSED = 'processed';
  static STATUS_FAILED = 'failed';
  static STATUS_CANCELLED = 'cancelled';

  static TYPE_DEPOSIT = 'deposit';
  static TYPE_WITHDRAW = 'withdraw';
  static TYPE_INVESTMENT = 'investment';
  static TYPE_DISTRIBUTION = 'distribution';
  static TYPE_FEE = 'fee';
  static TYPE_MARKET = 'market';
  static TYPE_SALE = 'sale';
  static TYPE_RETURN = 'return';

  get isStatusPending() {
    return this.status === ModelAccountWalletTransaction.STATUS_PENDING;
  }

  get isStatusProcessed() {
    return this.status === ModelAccountWalletTransaction.STATUS_PROCESSED;
  }

  get isStatusFailed() {
    return this.status === ModelAccountWalletTransaction.STATUS_FAILED;
  }

  get isStatusCancelled() {
    return this.status === ModelAccountWalletTransaction.STATUS_CANCELLED;
  }

  get isTypeDeposit() {
    return this.type === ModelAccountWalletTransaction.TYPE_DEPOSIT;
  }

  get isTypeWithdraw() {
    return this.type === ModelAccountWalletTransaction.TYPE_WITHDRAW;
  }

  get isTypeInvestment() {
    return this.type === ModelAccountWalletTransaction.TYPE_INVESTMENT;
  }

  get isTypeDistribution() {
    return this.type === ModelAccountWalletTransaction.TYPE_DISTRIBUTION;
  }

  get isTypeFee() {
    return this.type === ModelAccountWalletTransaction.TYPE_FEE;
  }

  get isTypeMarket() {
    return this.type === ModelAccountWalletTransaction.TYPE_MARKET;
  }

  get isTypeSale() {
    return this.type === ModelAccountWalletTransaction.TYPE_SALE;
  }

  get isTypeReturn() {
    return this.type === ModelAccountWalletTransaction.TYPE_RETURN;
  }
}
